import Typography from "@weave-design/typography";
import { ICustomZShapeType, CustomPanelType, CustomPanelTypeStatus } from "../../responses/customPanelTypes";
import { Parameters } from "../forge/docking-panels/content/parameters";
import { CustomComponentCard } from "./customComponentCard";
import { formatLength } from "./customComponentCommon";
import "./customPanelComponentCard.css";

type Props = {
    panel: ICustomZShapeType;
    selectLibraryComponent: (component: CustomPanelType) => void;
    currentCustomPanelTypeId?: string;
};

export const CustomZShapedComponentCard = ({ panel, selectLibraryComponent, currentCustomPanelTypeId }: Props) => {
    const leftWingDimension = panel.status === CustomPanelTypeStatus.Published
        ? formatLength(panel.leftWingLength)
        : "???";

    const shelfDimension = panel.status === CustomPanelTypeStatus.Published
        ? formatLength(panel.shelfLength)
        : "???";

    const rightWingDimension = panel.status === CustomPanelTypeStatus.Published
        ? formatLength(panel.rightWingLength)
        : "???";

    const height = panel.status === CustomPanelTypeStatus.Published
        ? formatLength(panel.height)
        : "???";

    return (
        <CustomComponentCard
            panel={panel}
            selectLibraryComponent={selectLibraryComponent}
            currentCustomPanelTypeId={currentCustomPanelTypeId}
            typeIcon="custom-panel-component-card-stats-custom-z-shaped-type"
            panelProperties={
                <Parameters>
                    <div>
                        <Typography>
                            Angles: {panel.angle1}°, {panel.angle2}°
                        </Typography>
                    </div>
                    <div>
                        <Typography>Left wing: {leftWingDimension}</Typography>
                    </div>
                    <div>
                        <Typography>Shelf: {shelfDimension}</Typography>
                    </div>
                    <div>
                        <Typography>Right wing: {rightWingDimension}</Typography>
                    </div>
                    <div>
                        <Typography>Height: {height}</Typography>
                    </div>
                </Parameters>
            }
        />
    );
};
